import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=3724807e&scoped=true&"
import script from "./GoogleLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724807e",
  null
  
)

export default component.exports